import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBackendCart } from '@rbi-ctg/menu';
import Currency from 'components/currency';

import { CurrencyLineSkeleton } from '../../currency-line-skeleton';

import { Total, TotalLabel, TotalsRow } from './styled';

const GrandTotalRow = styled(TotalsRow)`
  font-weight: bold;
  margin-top: 1rem;
  }
`;

interface GrandTotalProps {
  isLoading?: boolean;
  cart?: IBackendCart;
  serverOrderTip?: number;
  tipAmount: number;
}

const GrandTotal: React.FC<GrandTotalProps> = ({
  cart,
  serverOrderTip,
  tipAmount = 0,
  isLoading,
}) => {
  const { formatMessage } = useIntl();
  const { totalCents = 0 } = cart || {};

  return (
    <GrandTotalRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <TotalLabel>
            {formatMessage({
              id: 'total',
            })}
            {'* '}
          </TotalLabel>
          <Total data-testid="grand-total">
            <Currency amount={totalCents - Number(serverOrderTip) + tipAmount} />
          </Total>
        </>
      )}
    </GrandTotalRow>
  );
};

export default GrandTotal;
